// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

/*
 *
 * ----------------------------------------------- */
var swiperFv = document.querySelector(".swiper-fv");

if (swiperFv) {
  new Swiper(swiperFv, {
    speed: 1500,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperNonstop = document.querySelector(".swiper-nonstop-slide");

if (swiperNonstop) {
  new Swiper(swiperNonstop, {
    observer: true,
    observeParents: true,
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 15,
    initialSlide: 2,
    loop: true,
    speed: 7500,
    allowTouchMove: false,
    autoplay: {
      enabled: true,
      delay: 1,
    },
    breakpoints: {
      767: {
        spaceBetween: 40,
      },
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperColumn = document.querySelector(".swiper-column");

if (swiperColumn) {
  new Swiper(swiperColumn, {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 25,
    slideToClickedSlide: true,
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 40,
        centeredSlides: false,
        allowTouchMove: false,
        slideToClickedSlide: false,
      },
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperThumbnail = document.querySelector(".swiper-thumbnail");

if (swiperThumbnail) {
  new Swiper(swiperThumbnail, {
    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 25,
    slideToClickedSlide: true,
    breakpoints: {
      767: {
        spaceBetween: 40,
        slidesPerView: 3,
        centeredSlides: false,
        allowTouchMove: false,
        slideToClickedSlide: false,
      },
    },
  });
}

/*
 *
 * ----------------------------------------------- */
var swiperJob = document.querySelector(".swiper-job");

if (swiperJob) {
  new Swiper(swiperJob, {
    slidesPerView: 3,
    spaceBetween: 0,

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    on: {
      init: function () {
        if (this.slides.length <= 2) {
          this.el.classList.add("swiper-2-slide");
        }

        if (this.slides.length <= 0) {
          $(".container-slider").addClass("hide");
        }
      },
    },
  });
}
